import {Directive, Input, OnInit} from '@angular/core';
import {FormlyFieldConfig, FormlyForm} from '@ngx-formly/core';
import {get} from 'lodash-es';
import {traverse} from '../formly-utils';

const injectOptions = (fields: FormlyFieldConfig[], data: any): void => {
  const compareFn = (key: string, value: any): boolean => {
    return key === 'options' && typeof value === 'object'
      && value.hasOwnProperty('source') && value.hasOwnProperty('label') && value.hasOwnProperty('value')
  };
  const processFn = (value: any): any => {
    const sourceArray = get(data, value.source);
    return sourceArray.map((s: any) => ({
      value: get(s, value.value),
      label: get(s, value.label)
    }));
  };
  return traverse(fields, compareFn, processFn);
};

@Directive({
  selector: '[zlInjectOptions]',
  standalone: true,
})
export class InjectOptionsDirective implements OnInit {
  @Input() zlInjectOptions: any;

  constructor(private formly: FormlyForm) {
  }

  ngOnInit(): void {
    if (!!this.zlInjectOptions) {
      injectOptions(this.formly.fields, this.zlInjectOptions)
    }
  }

}
